import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import { trackError } from "./utils/errorTracker";
import reportWebVitals from "./reportWebVitals";
import "react-camera-media-stream/dist/index.css";
import ReactGA from "react-ga4";

ReactGA.initialize([
  {
    trackingId: "G-KRNL7S0KEH",
  },
]);

// Global JS error tracking
window.addEventListener("error", (event) => {
  // "Script error." = cross-origin script (extensions, analytics, tawk.to) — no useful details
  if (!event.message || event.message === "Script error.") return;

  trackError({
    type: "js_error_global",
    message: event.message,
    source: event.filename,
    line: event.lineno,
    col: event.colno,
  });
});

window.addEventListener("unhandledrejection", (event) => {
  const reason = event.reason;
  const message = String(reason);

  // Only track errors with a stack trace from our code — others are extensions/tawk.to/analytics
  const stack = reason?.stack || "";
  if (!stack.includes("windtransfer.net") && !stack.includes("localhost")) return;

  trackError({
    type: "js_promise_error",
    message,
    stack,
  });
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
